export default __webpack_public_path__ + "static/media/icons8-image-256.d080ee87.svg";